export default "__VITE_ASSET__D9fEaI10__"